module.exports = __webpack_public_path__ + "static/img/2.9b55845.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/4/1/zh/2.png
// module id = MUcw
// module chunks = 0